export default __webpack_public_path__ + "static/media/stoneBrick.c05b36e1.jpg";